// extracted by mini-css-extract-plugin
export default {"Hero":"hero_Hero__hTRZQ","Overlay":"hero_Overlay__9+MYi","MainImage":"hero_MainImage__QiiPx"};